import React, { useState } from 'react'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'

import { useMutation } from '@apollo/client'
import { MC_HEX_COLOR } from 'graphql/mutations'
import styles from '../hexColors.module.scss'

const HexColorCreate = ({ setCreate, update, loading }) => {
  const [name, setName] = useState('')
  const [hex, setHex] = useState('000000')

  const [call] = useMutation(MC_HEX_COLOR)

  const onSubmit = () => {
    loading(true)
    setCreate(false)
    call({
      variables: {
        name: name,
        hex: hex,
      },
    })
      .then(res => {
        update()
      })
      .catch(err => console.error(err))
  }

  return (
    <div className={styles.vTypeFormRoot}>
      <div className={styles.formWrapper}>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Color Name"
          type="text"
          value={name}
          onChange={e => setName(e.target.value)}
          fullWidth
        />
        <TextField
          autoFocus
          margin="dense"
          id="hex"
          label="HexCode"
          type="text"
          fullWidth
          value={hex}
          onChange={e => setHex(e.target.value)}
        />
        <div
          style={{ backgroundColor: `#${hex}`, width: '80px', height: '80px' }}
        />

        <Button
          variant="contained"
          onClick={() => onSubmit()}
          className={styles.submit}
          color="primary"
        >
          Submit
        </Button>
      </div>
    </div>
  )
}

export default HexColorCreate
